import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/mobile-stt-1.mp4")